// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.deliveryterms', {
        url: '/deliveryterms?searchTerm',
        views: {
            'baseList': {
            templateUrl: 'main/base/deliveryterms/deliveryterms.tpl.html',
            controller: 'DeliveryTermsController as vm'
        }},
        resolve: {
            deliveryterms: deliverytermsResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function deliverytermsResolver(DeliveryTermsApiService, $stateParams) {
    return DeliveryTermsApiService.getDeliveryTerms({ page: 0, searchTerm:$stateParams.searchTerm, pageSize:null});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function DeliveryTermsController($rootScope, $state, $scope, deliveryterms, DeliveryTermsApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.deliveryterms = deliveryterms;
    vm.selectedDeliveryTermId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.deliveryTermId; }, function(newValue, oldValue) {
            vm.selectedDeliveryTermId = parseInt($state.params.deliveryTermId,10);
        });
        $rootScope.$on('DeliveryTerm.Inserted', function(event, response) {
        });
        $rootScope.$on('DeliveryTerm.Updated', function(event, response) {
        });
        $rootScope.$on('DeliveryTerm.Deleted', function(event, response) {
        });
        $rootScope.$on('DeliveryTerm.Changed', function(event, response) {
            loadDeliveryTerms();
        });
    }

    function loadDeliveryTerms() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        DeliveryTermsApiService.getDeliveryTerms(request).then(function(response) {
            vm.deliveryterms = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadDeliveryTerms();
    }

}

angular
    .module('base.deliveryterms', ['deliveryterms.api','deliveryterms.deliveryterm'])
    .config(stateConfig)
    .controller('DeliveryTermsController', DeliveryTermsController);
